import React from 'react'
import { Outlet } from 'react-router-dom';
import Header from 'components/Header';
import Sidebar from 'components/Sidebar';
import logo from 'assets/img/logo.png'


export default function Main() {

    return (
        <>
            {/* <div className='preloader'>
                <img src={logo} className='animation__shake' alt="logo" height="60" width="60" />
            </div> */}

            <Header />
            <Sidebar />

            <div className='content-wrapper px-4 py-2 d-flex' >
                <div className='content w-100 p-0'>
                    <Outlet />
                </div>
            </div>

            {/* <div className='main-footer'>
                footer
            </div> */}
        </>
    )
}
